export default __webpack_public_path__ + "static/media/Manipal.bd7344b3.png";